import { Map } from 'immutable'
import { EReviewsTypes } from 'app/constants/reviews'
import { IBarChartGroupedReviewerType } from './ComponentsForT2/BarChartGrouped/interface'
import { IRadarChartT2ReviewersResult } from './ComponentsForT2/RadarChartT2/interface'

export enum EReviewerTypes {
  Self = 'Self',
  Supervisors = 'Supervisors',
  Direct = 'Direct',
  Peers = 'Peers',
}

export interface IReportsProps {
  report: Map<string, any>
  isPending: boolean
  organization: Map<string, any>
}

export interface IReportsOrganization {
  id: number
  name: string
  logo: string
}

interface IReviewersAvgByCompetency {
  competency: string
  Direct?: number
  Peers?: number
  Self: number
  Supervisors?: number
}

interface IByEachQuestion {
  title: string
  result: IEstimate[]
}

interface IByEachQuestionForT2 {
  title: string
  result: IEstimateForT2[]
}

interface IEstimateForT2 {
  reviewerType: EReviewerTypes
  t1: number
  t2: number
}

export interface IOverallAvgByCompetency {
  competency: string
  overall: number
  byAllQuestions: IEstimate[]
  byEachQuestion: IByEachQuestion[]
}

export interface IOverallAvgByCompetencyForT2 {
  competency: string
  overall: number
  byEachQuestion: IByEachQuestionForT2[]
  participantChange: IBarChartGroupedReviewerType[]
  teamChange: IBarChartGroupedReviewerType[]
}

interface IAnswer {
  Self: string
  Supervisors?: string[]
  Peers?: string[]
  Direct?: string[]
}

interface IAnswersToEachQuestion {
  question: string
  answers: IAnswer[]
}

interface IEstimate {
  reviewerType: EReviewerTypes
  avg: number
  teamAvg: number
}

export interface IReviewers {
  employee?: number
  superior?: number
  peer?: number
}

export interface IReport {
  reviewType: EReviewsTypes
  firstName: string
  lastName: string
  email: string
  reviewersAvgByCompetency: IReviewersAvgByCompetency[] | IRadarChartT2ReviewersResult
  overallAvgByReviewerType: IEstimate[]
  overallAvgByCompetency: IOverallAvgByCompetency[] | IOverallAvgByCompetencyForT2[]
  answersToEachQuestion: IAnswersToEachQuestion[]
  reviewers: IReviewers
  reviewersRatingsT2: IBarChartGroupedReviewerType[]
}

export interface IReportT2 {
  reviewersAvgByCompetency: IRadarChartT2ReviewersResult
  reviewersRatingsT2: IBarChartGroupedReviewerType[]
  answersToEachQuestion: IAnswersToEachQuestion[]
  overallAvgByCompetency: IOverallAvgByCompetencyForT2[]
  reviewers: IReviewers
}
